import React, { useState, useEffect } from 'react';
import api from '../services/api';
import { IconeValide, IconeHorloge } from './IconesSVG';

const iso = (d) => d.toISOString().slice(0, 10);

// Formulaire de creation d'une delegation de signature.
// Les regles sont revalidees par le serveur : ce qui suit ne fait qu'eviter des
// aller-retours evidents et guider la saisie.
export default function FormulaireDelegation({ roleUser, filialeId, onCree }) {
  const demain = new Date(Date.now() + 86400000);
  const [collegues, setCollegues] = useState([]);
  const [delegueId, setDelegueId] = useState('');
  const [dateDebut, setDateDebut] = useState(iso(new Date()));
  const [dateFin, setDateFin] = useState(iso(demain));
  const [montantMax, setMontantMax] = useState('');
  const [enCours, setEnCours] = useState(false);
  const [erreur, setErreur] = useState('');

  useEffect(() => {
    // Un DG ne peut deleguer qu'au sein de sa filiale ; le PDG a tout le monde.
    api.get('/users')
      .then((res) => {
        const tous = (res.data || []).filter((u) => u.actif !== false);
        setCollegues(roleUser === 'pdg'
          ? tous
          : tous.filter((u) => (u.filiale_id || u.filiale?._id) === filialeId));
      })
      .catch(() => setCollegues([]));
  }, [roleUser, filialeId]);

  const datesValides = dateDebut && dateFin && dateFin > dateDebut;

  const soumettre = async () => {
    if (!delegueId) { setErreur('Choisissez un bénéficiaire.'); return; }
    if (!datesValides) { setErreur('La date de fin doit suivre la date de début.'); return; }
    setEnCours(true); setErreur('');
    try {
      await api.post('/delegations', {
        delegue_id: delegueId,
        date_debut: dateDebut,
        date_fin: dateFin,
        montant_max: montantMax === '' ? null : Number(montantMax),
      });
      setDelegueId(''); setMontantMax('');
      onCree && onCree();
    } catch (e) {
      setErreur(e.response?.data?.message || e.message || 'Création impossible');
    } finally { setEnCours(false); }
  };

  return (
    <div style={s.carte}>
      <div style={s.titre}>Nouvelle délégation</div>

      <label style={s.label} htmlFor="deleg-beneficiaire">Bénéficiaire</label>
      <select id="deleg-beneficiaire" value={delegueId} style={s.champ}
        onChange={(e) => setDelegueId(e.target.value)}>
        <option value="">— Choisir —</option>
        {collegues.map((u) => (
          <option key={u._id || u.id} value={u._id || u.id}>
            {u.prenom} {u.nom} ({u.identifiant})
          </option>
        ))}
      </select>

      <div style={s.grille}>
        <div>
          <label style={s.label} htmlFor="deleg-debut">Date de début</label>
          <input id="deleg-debut" type="date" value={dateDebut} style={s.champ}
            onChange={(e) => setDateDebut(e.target.value)} />
        </div>
        <div>
          <label style={s.label} htmlFor="deleg-fin">Date de fin</label>
          <input id="deleg-fin" type="date" value={dateFin} min={dateDebut} style={s.champ}
            onChange={(e) => setDateFin(e.target.value)} />
        </div>
      </div>

      <label style={s.label} htmlFor="deleg-montant">Montant maximum (facultatif)</label>
      <input id="deleg-montant" type="number" min="0" value={montantMax} style={s.champ}
        placeholder="Aucun plafond" onChange={(e) => setMontantMax(e.target.value)} />

      {erreur && <div style={s.erreur}>{erreur}</div>}

      <button type="button" onClick={soumettre} disabled={enCours || !datesValides} style={s.valider}>
        {enCours
          ? <><IconeHorloge taille={14} /> Création…</>
          : <><IconeValide taille={14} /> Créer la délégation</>}
      </button>
    </div>
  );
}

const s = {
  carte: { background: '#fff', border: '0.5px solid #e5e7eb', borderRadius: 14, padding: 20, boxShadow: '0 1px 4px rgba(0,0,0,0.04)' },
  titre: { fontSize: 15, fontWeight: 800, color: '#0D1B2A', marginBottom: 4 },
  label: { display: 'block', fontSize: 11, fontWeight: 700, color: '#555', textTransform: 'uppercase', letterSpacing: '0.04em', marginBottom: 5, marginTop: 14 },
  champ: { width: '100%', padding: '10px', borderRadius: 8, border: '1.5px solid #E5E7EB', fontSize: 13, fontFamily: 'inherit', boxSizing: 'border-box', background: '#fff', minHeight: 42 },
  grille: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10 },
  erreur: { background: '#FDEDEC', border: '1px solid #C0392B', color: '#96281B', borderRadius: 8, padding: '9px 12px', fontSize: 12, marginTop: 14 },
  valider: { width: '100%', marginTop: 18, padding: '12px', borderRadius: 10, border: 'none', background: '#1E8449', color: '#fff', fontSize: 13, fontWeight: 700, cursor: 'pointer', fontFamily: 'inherit', minHeight: 44, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 6 },
};
